export enum ApiClientType {
    mock = 'mock',
    server = 'server',
}
